module.exports = __webpack_public_path__ + "img/landing-error.478d6462.jpg";